import React from 'react';
import { BackupConfig } from './types';

interface Props {
  config: BackupConfig;
  onConfigChange: (c: BackupConfig) => void;
  onOpenGithubConnect?: () => void;
}

const GitHubConfigForm: React.FC<Props> = ({ config, onConfigChange, onOpenGithubConnect }) => {
  return (
    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="md:col-span-2">
        <button
          type="button"
          onClick={onOpenGithubConnect}
          className="px-3 py-2 bg-slate-900 text-white rounded"
        >
          Connect GitHub
        </button>
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Token
        </label>
        <input
          type="password"
          value={config.github?.token || ''}
          onChange={(e) =>
            onConfigChange({
              ...config,
              github: { ...(config.github || {}), token: e.target.value },
            })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Owner
        </label>
        <input
          type="text"
          value={config.github?.owner || ''}
          onChange={(e) =>
            onConfigChange({
              ...config,
              github: { ...(config.github || {}), owner: e.target.value },
            })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Repository
        </label>
        <input
          type="text"
          value={config.github?.repo || ''}
          onChange={(e) =>
            onConfigChange({
              ...config,
              github: { ...(config.github || {}), repo: e.target.value },
            })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Branch
        </label>
        <input
          type="text"
          value={config.github?.branch || ''}
          onChange={(e) =>
            onConfigChange({
              ...config,
              github: { ...(config.github || {}), branch: e.target.value },
            })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
      <div className="md:col-span-2">
        <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">
          Directory (path inside repo)
        </label>
        <input
          type="text"
          placeholder="e.g., backups/"
          value={config.github?.directory || ''}
          onChange={(e) =>
            onConfigChange({
              ...config,
              github: { ...(config.github || {}), directory: e.target.value },
            })
          }
          className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700"
        />
      </div>
    </div>
  );
};

export default GitHubConfigForm;
